import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
import { computed, ref, watch } from 'vue';
import { generateRoutes } from './FuseData';
import Fuse from 'fuse.js';
import { filterRouters } from '@/utils/route';
import { useRouter } from 'vue-router';

// 控制 search 显示

export default {
  __name: 'index',
  setup(__props) {
    const isShow = ref(false);
    // el-select 实例
    const headerSearchSelectRef = ref(null);
    const onShowClick = () => {
      isShow.value = !isShow.value;
      headerSearchSelectRef.value.focus();
    };

    // search 相关
    const search = ref('');
    // 搜索结果
    const searchOptions = ref([]);
    // 搜索方法
    const querySearch = query => {
      if (query !== '') {
        searchOptions.value = fuse.search(query);
      } else {
        searchOptions.value = [];
      }
    };
    // 选中回调
    const onSelectChange = val => {
      router.push(val.path);
      onClose();
    };

    // 检索数据源
    const router = useRouter();
    const searchPool = computed(() => {
      const filterRoutes = filterRouters(router.getRoutes());
      return generateRoutes(filterRoutes);
    });
    /**
     * 搜索库相关
     */
    let fuse;
    const initFuse = searchPool => {
      fuse = new Fuse(searchPool, {
        // 是否按优先级进行排序
        shouldSort: true,
        // 匹配算法放弃的时机， 阈值 0.0 需要完美匹配（字母和位置），阈值 1.0 将匹配任何内容。
        threshold: 0.4,
        // 匹配长度超过这个值的才会被认为是匹配的
        minMatchCharLength: 1,
        // 将被搜索的键列表。 这支持嵌套路径、加权搜索、在字符串和对象数组中搜索。
        // name：搜索的键
        // weight：对应的权重
        keys: [{
          name: 'title',
          weight: 0.7
        }, {
          name: 'path',
          weight: 0.3
        }]
      });
    };
    initFuse(searchPool.value);

    /**
     * 关闭 search 的处理事件
     */
    const onClose = () => {
      headerSearchSelectRef.value.blur();
      isShow.value = false;
      searchOptions.value = [];
      search.value = '';
    };
    /**
     * 监听 search 打开，处理 close 事件
     */
    watch(isShow, val => {
      if (val) {
        document.body.addEventListener('click', onClose);
      } else {
        document.body.removeEventListener('click', onClose);
      }
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          show: isShow.value
        }, "header-search"])
      }, [_createVNode(_component_svg_icon, {
        id: "guide-search",
        "class-name": "search-icon",
        icon: "search",
        onClick: _withModifiers(onShowClick, ["stop"])
      }), _createVNode(_component_el_select, {
        ref_key: "headerSearchSelectRef",
        ref: headerSearchSelectRef,
        class: "header-search-select",
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        filterable: "",
        "default-first-option": "",
        remote: "",
        placeholder: "Search",
        "remote-method": querySearch,
        onChange: onSelectChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchOptions.value, option => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: option.item.path,
            label: option.item.title.join(' > '),
            value: option.item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])], 2);
    };
  }
};